export default {
  label: {
    mentionsText: 'Mentions',
  },
};
